// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","532":"60472bb95f94d4066369f32717bcf041bda24f6f","985":"component---src-pages-privacy-tsx"}[chunkId] + "-" + {"245":"ef9d3fffbce085f4986c","453":"3b3eef1d6f522f0e6435","532":"48728e922cc28dd9108f","985":"a5dffd58a401d3bf3bf2"}[chunkId] + ".js";
};